import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
});

class ContainedButton extends React.Component  {

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e){
    this.props.action();
  }

  render(){
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Button variant="contained" color="primary" onClick={this.handleClick}>{this.props.name}</Button>
      </div>
    );
  }
}

export default withStyles(useStyles)(ContainedButton);
